import { 
  GET_SYNDI_CLICKS_DASHBOARD_STICKY_COLUMNS, 
  GET_SYNDI_CLICKS_DASHBOARD_STICKY_COLUMNS_ERROR, 
  GET_SYNDI_CLICKS_DASHBOARD_STICKY_COLUMNS_SUCCESS,
  UPDATE_SYNDI_CLICKS_DASHBOARD_STICKY_COLUMNS, 
  UPDATE_SYNDI_CLICKS_DASHBOARD_STICKY_COLUMNS_ERROR, 
  UPDATE_SYNDI_CLICKS_DASHBOARD_STICKY_COLUMNS_SUCCESS 
} from "./actionTypes"

const initialState = {
  error: null,
  user_column_preference_syndi_clicks_dashboard: null,
  loading: false
}

const UserSyndiClicksDashboardColumnPreference = (state = initialState, action) => {
  switch (action.type) {
    case GET_SYNDI_CLICKS_DASHBOARD_STICKY_COLUMNS:
      return {
        ...state,
        loading: true
      }

    case GET_SYNDI_CLICKS_DASHBOARD_STICKY_COLUMNS_SUCCESS:
      return {
        ...state,
        user_column_preference_syndi_clicks_dashboard: action.payload,
        loading: false
      }

    case GET_SYNDI_CLICKS_DASHBOARD_STICKY_COLUMNS_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false
      }

    case UPDATE_SYNDI_CLICKS_DASHBOARD_STICKY_COLUMNS:
      return {
        ...state,
        loading: true
      }

    case UPDATE_SYNDI_CLICKS_DASHBOARD_STICKY_COLUMNS_SUCCESS:
      return {
        ...state,
        user_column_preference_syndi_clicks_dashboard: action.payload,
        loading: false
      }

    case UPDATE_SYNDI_CLICKS_DASHBOARD_STICKY_COLUMNS_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false
      }
    default:
      return state
  }
}

export default UserSyndiClicksDashboardColumnPreference;
